import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { 
  RotateCcw, 
  Shuffle, 
  List, 
  ArrowRight
} from 'lucide-react';
import './QuestionRetryCard.css';

const QuestionRetryCard = ({ score, onRetrySame, onNewQuestion, onSelectAlternative, alternatives = [] }) => {
  const { t } = useTranslation();
  const [showAlternatives, setShowAlternatives] = useState(false);

  return (
    <div className="questionRetryCard">
      <div className="questionRetryCard__header">
        <h3 className="questionRetryCard__title">
          {t('recordingQuestion.retry.title')}
        </h3>
        <p className="questionRetryCard__message">
          {t('recordingQuestion.retry.message', { score })}
        </p>
      </div>

      <div className="questionRetryCard__actions">
        <button 
          className="questionRetryCard__btn questionRetryCard__btn--primary"
          onClick={onRetrySame}
        >
          <RotateCcw size={16} />
          {t('recordingQuestion.retry.same')}
        </button>
        <button 
          className="questionRetryCard__btn questionRetryCard__btn--secondary"
          onClick={onNewQuestion}
        >
          <Shuffle size={16} />
          {t('recordingQuestion.retry.new')}
        </button>
        <button 
          className="questionRetryCard__btn questionRetryCard__btn--text"
          onClick={() => setShowAlternatives(!showAlternatives)}
        >
          <List size={16} />
          {t('recordingQuestion.retry.alternatives')}
        </button>
      </div>

      {showAlternatives && (
        <div className="questionRetryCard__alternatives">
          <h4 className="questionRetryCard__altTitle">
            {t('alternatives.title')}
          </h4>
          <ul className="questionRetryCard__altList">
            {alternatives.map((alt, index) => (
              <li key={index} className="questionRetryCard__altItem">
                <div className="questionRetryCard__altContent">
                  <span className="questionRetryCard__altName">
                    {t(alt.descriptionKey)}
                  </span>
                  <span className="questionRetryCard__altReason">
                    {t(alt.reasonKey)}
                  </span>
                </div>
                <button 
                  className="questionRetryCard__altSelect"
                  onClick={() => onSelectAlternative(alt)}
                >
                  {t('alternatives.select')}
                  <ArrowRight size={14} />
                </button>
              </li>
            ))}
            {alternatives.length === 0 && (
               <p style={{ textAlign: 'center', color: '#6b7280', fontSize: '0.875rem', padding: '1rem' }}>
                  Generating suggestions...
               </p>
            )}
          </ul>
        </div>
      )}
    </div>
  );
};

export default QuestionRetryCard;
